const TAB_ID_KEY = 'tab_id';

export const getTabId = (): string => {
  try {
    let tabId = sessionStorage.getItem(TAB_ID_KEY);
    if (!tabId) {
      tabId = crypto.randomUUID();
      sessionStorage.setItem(TAB_ID_KEY, tabId);
    }
    return tabId;
  } catch {
    return 'N/A';
  }
};
